import { Component, forwardRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { UserDao } from '@app/dao/user/user.dao';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { EaEarningFormComponent } from '../ea-earning-form/ea-earning-form.component';
import { ObjectiveDao } from '@app/dao/objective/objective.dao';
import { PrNotificationService } from '@app/components/pr-notification/pr-notification.service';
import { PrObjectiveFormBuilder } from './ea-objective-form.builder';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

@Component({
    selector: 'ea-objective-form',
    templateUrl: './ea-objective-form.component.html',
    styleUrls: ['./ea-objective-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaEarningFormComponent),
        },
    ],
    standalone: false
})
export class EaObjectiveFormComponent
  extends PrObjectiveFormBuilder
  implements OnInit
{
  users: any[];
  reference: any[];

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private objectiveDao: ObjectiveDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.objectiveDao.getReference(),
    ]).subscribe(([users, reference]) => {
      this.users = users;
      this.reference = reference;
    });
  }

  extract() {
    let dto = super.extract();
    dto.accountId = this.users[0].accountId;
    return dto;
  }

  onSubmit() {
    this.prFormService.loading();
    this.objectiveDao.saveObjective(this.extract()).subscribe(
      success => {
        this.prFormService.loaded();
        this.notificationService.success('Succés', 'La sauvegarde a réussi');
      },
      errors => {
        console.error(errors);
        this.prFormService.loaded();
        this.notificationService.error('Erreur', 'La sauvegarde a échoué');
      },
    );
  }
}
